import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Admin pages get the mark upside down; the public site keeps it the right way up.
// Shared CV pages carry the CV's own monogram — no restore.dental branding.
const ICONS = {
  public: [
    ["link[rel='icon'][type='image/x-icon']", '/favicon.ico?v=3'],
    ["link[rel='icon'][sizes='32x32']", '/favicon-32x32.png?v=3'],
    ["link[rel='icon'][sizes='64x64']", '/favicon-64x64.png?v=3'],
  ],
  admin: [
    ["link[rel='icon'][type='image/x-icon']", '/favicon-admin.ico?v=2'],
    ["link[rel='icon'][sizes='32x32']", '/favicon-admin-32x32.png?v=2'],
    ["link[rel='icon'][sizes='64x64']", '/favicon-admin-64x64.png?v=2'],
  ],
  cv: [
    ["link[rel='icon'][type='image/x-icon']", '/cv/favicon.ico'],
    ["link[rel='icon'][sizes='32x32']", '/cv/logo192.png'],
    ["link[rel='icon'][sizes='64x64']", '/cv/logo192.png'],
  ],
};

const iconSetFor = (pathname) => {
  if (pathname.startsWith('/admin')) return ICONS.admin;
  if (pathname.startsWith('/cv/')) return ICONS.cv;
  return ICONS.public;
};

const FaviconSwitcher = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const set = iconSetFor(pathname);
    set.forEach(([selector, href]) => {
      const link = document.head.querySelector(selector);
      if (link && link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
  }, [pathname]);

  return null;
};

export default FaviconSwitcher;
